import { images } from "./images";

export const caseStudyList = [
  {
    id: "motleycrew",
    img: images.motleyCrew,
    tags: ["Design", "Development"],
    title: "UX Design and Web Development for Motley Crew",
    shortTitle: "Motley Crew",
    name: "Marketing",
    date: "JULY 28, 2024",
  },
  {
    id: "majdai",
    img: images.majdAi,
    tags: ["Design", "Development"],
    title: "UX Design and Web Development for MAJD AI",
    shortTitle: "MAJD AI",
    name: "AI Solutions",
    date: "FEB 28, 2025",
  },
  {
    id: "epsilon",
    img: images.epsilonEnergy,
    tags: ["Design", "Development"],
    title: "UX Design and Web Development for Epsilon Energy",
    shortTitle: "Epsilon Energy",
    name: "Green Energy",
    date: "OCT 30, 2025",
  },
  {
    id: "hunter",
    img: images.hunterCase,
    tags: ["Design", "Development"],
    title: "UX Design and Web Development for Hunter by Knogin",
    shortTitle: "Hunter by Knogin",
    name: "Cyber Security",
    date: "DEC 28, 2023",
  },
  {
    id: "gate8",
    img: images.gate8Case,
    tags: ["Design", "Development"],
    title: "UX Design and Web Development for Gate8",
    shortTitle: "Gate8",
    name: "E-Commerce",
    date: "DEC 28, 2023",
  },
  {
    id: "blue_bricks",
    img: images.blueBricksCase,
    tags: ["Design", "Development"],
    title: "UX Design and Web Development for Bluebricks",
    shortTitle: "Bluebricks",
    name: "Cyber Security",
    date: "DEC 28, 2023",
  },
];
